import { useCrs } from "@evergis/react";
import { usePostgresLayer } from "./usePostgresLayer";

export const useLayerCrs = (layerName: string) => {
  const { postgresLayer, loading } = usePostgresLayer(layerName, { waitInput: true });
  const crs = useCrs(postgresLayer.sr);

  return [crs, { loading }] as const;
};
